import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSiteConfig } from '../contexts/SiteConfigContext';
import { api } from '../lib/api';
import {
  Star, Image as ImgIcon, ShoppingBag, Tag, Calendar, MessageSquare, ArrowRight,
} from 'lucide-react';

const Card = ({ icon: Icon, label, value, to, color = '#c4477a' }) => (
  <Link
    to={to}
    className="bg-white border border-gray-200 rounded-xl p-5 hover:border-[#c4477a]/40 transition-colors flex items-center gap-4 group"
  >
    <div className="w-12 h-12 rounded-lg flex items-center justify-center shrink-0" style={{ backgroundColor: '#fdf2f5' }}>
      <Icon className="w-5 h-5" style={{ color }} strokeWidth={1.7} />
    </div>
    <div className="flex-1 min-w-0">
      <div className="text-xs text-gray-500 uppercase tracking-wide">{label}</div>
      <div className="font-display text-2xl text-[#5a1d3b]" style={{ fontWeight: 500 }}>{value}</div>
    </div>
    <ArrowRight className="w-4 h-4 text-gray-400 group-hover:translate-x-0.5 transition-transform" />
  </Link>
);

const AdminDashboard = () => {
  const { config } = useSiteConfig();
  const [stats, setStats] = useState({ bookings: 0, messages: 0 });

  useEffect(() => {
    const load = async () => {
      try {
        const [b, m] = await Promise.all([
          api.get('/admin/bookings'),
          api.get('/admin/messages'),
        ]);
        setStats({ bookings: b.data.length, messages: m.data.length });
      } catch {
        // ignore
      }
    };
    load();
  }, []);

  return (
    <div className="max-w-6xl">
      <h1 className="font-display text-3xl text-[#5a1d3b] mb-1" style={{ fontWeight: 500 }}>Dashboard</h1>
      <p className="text-gray-500 mb-8">Manage your website content from here.</p>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        <Card icon={Star} label="Services" value={config.services?.length || 0} to="/admin/services" />
        <Card icon={Tag} label="Pricing Categories" value={config.pricing?.length || 0} to="/admin/pricing" />
        <Card icon={ImgIcon} label="Gallery Images" value={config.gallery?.length || 0} to="/admin/gallery" />
        <Card icon={ShoppingBag} label="Products" value={config.products?.length || 0} to="/admin/products" />
        <Card icon={Calendar} label="Bookings" value={stats.bookings} to="/admin/bookings" />
        <Card icon={MessageSquare} label="Messages" value={stats.messages} to="/admin/messages" />
      </div>

      <div className="mt-10 bg-white border border-gray-200 rounded-xl p-6">
        <h3 className="font-display text-lg text-[#5a1d3b] mb-3" style={{ fontWeight: 500 }}>Quick Tips</h3>
        <ul className="text-sm text-gray-600 space-y-2 list-disc ps-5">
          <li>All your changes are saved instantly to the database and reflected on the live site.</li>
          <li>Images are stored as base64. Keep them under ~1MB each for best performance.</li>
          <li>Use the multi-language fields (DE / EN / AR) for international visitors.</li>
          <li>Toggle &quot;Visible&quot; to hide items without deleting them.</li>
        </ul>
      </div>
    </div>
  );
};

export default AdminDashboard;
